"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCountries = getCountries;
exports.getLocale = getLocale;
exports.getLocales = getLocales;
exports.getAllReviewSources = getAllReviewSources;
exports.getReviewSourceNameById = getReviewSourceNameById;
exports.getReviewSourceById = getReviewSourceById;
exports.getReviewSourceByName = getReviewSourceByName;
var localization = require("./localization");
var countriesSource = require("../metadata/countries.json");
var localesSource = require("../metadata/locales.json");
var types_1 = require("./types");
var countries = countriesSource;
var locales = localesSource;
var defaultLocale = "en-US";
// Legacy sources for old reviews
var legacyReviewSources = [
    {
        id: 2,
        name: types_1.ReviewSourceNames.LegacyUniqueLinkName,
        isVerified: true,
        sourceGroup: types_1.SourceGroups.GeneratedLink,
        defaultVerificationLevel: types_1.DefaultVerificationLevels.Invited
    },
    {
        id: 3,
        name: types_1.ReviewSourceNames.LegacyAfsName,
        isVerified: true,
        sourceGroup: types_1.SourceGroups.AutomaticInvitation,
        defaultVerificationLevel: types_1.DefaultVerificationLevels.Verified
    },
    {
        id: 1,
        name: types_1.ReviewSourceNames.LegacyKickstartName,
        isVerified: true,
        sourceGroup: types_1.SourceGroups.ManualInvitation,
        defaultVerificationLevel: types_1.DefaultVerificationLevels.Invited
    },
    {
        id: 5,
        name: types_1.ReviewSourceNames.LegacyTrustpilotName,
        isVerified: false,
        sourceGroup: types_1.SourceGroups.Organic,
        defaultVerificationLevel: types_1.DefaultVerificationLevels.NotVerified
    },
];
// Valid sources for new reviews
var currentReviewSources = [
    {
        id: 10,
        name: types_1.ReviewSourceNames.Afsv1Name,
        isVerified: true,
        sourceGroup: types_1.SourceGroups.AutomaticInvitation,
        defaultVerificationLevel: types_1.DefaultVerificationLevels.Verified
    },
    {
        id: 11,
        name: types_1.ReviewSourceNames.Afsv2Name,
        isVerified: true,
        sourceGroup: types_1.SourceGroups.AutomaticInvitation,
        defaultVerificationLevel: types_1.DefaultVerificationLevels.Verified
    },
    {
        id: 12,
        name: types_1.ReviewSourceNames.BasicLinkName,
        isVerified: false,
        sourceGroup: types_1.SourceGroups.BasicInvitation,
        defaultVerificationLevel: types_1.DefaultVerificationLevels.Invited
    },
    {
        id: 13,
        name: types_1.ReviewSourceNames.BigCommerceName,
        isVerified: true,
        sourceGroup: types_1.SourceGroups.AutomaticInvitation,
        defaultVerificationLevel: types_1.DefaultVerificationLevels.Verified
    },
    {
        id: 14,
        name: types_1.ReviewSourceNames.BusinessGeneratedLinkName,
        isVerified: true,
        sourceGroup: types_1.SourceGroups.GeneratedLink,
        defaultVerificationLevel: types_1.DefaultVerificationLevels.Invited
    },
    {
        id: 15,
        name: types_1.ReviewSourceNames.CopyPasteInvitationName,
        isVerified: true,
        sourceGroup: types_1.SourceGroups.ManualInvitation,
        defaultVerificationLevel: types_1.DefaultVerificationLevels.Invited
    },
    {
        id: 16,
        name: types_1.ReviewSourceNames.EmbeddedUniqueLinkFormName,
        isVerified: true,
        sourceGroup: types_1.SourceGroups.EmbeddedReviewForm,
        defaultVerificationLevel: types_1.DefaultVerificationLevels.Invited
    },
    {
        id: 17,
        name: types_1.ReviewSourceNames.EmbeddedBusinessGeneratedLinkFormName,
        isVerified: true,
        sourceGroup: types_1.SourceGroups.EmbeddedReviewForm,
        defaultVerificationLevel: types_1.DefaultVerificationLevels.Invited
    },
    {
        id: 18,
        name: types_1.ReviewSourceNames.FileUploadInvitationName,
        isVerified: true,
        sourceGroup: types_1.SourceGroups.ManualInvitation,
        defaultVerificationLevel: types_1.DefaultVerificationLevels.Invited
    },
    {
        id: 19,
        name: types_1.ReviewSourceNames.InvitationApiName,
        isVerified: true,
        sourceGroup: types_1.SourceGroups.AutomaticInvitation,
        defaultVerificationLevel: types_1.DefaultVerificationLevels.Verified
    },
    {
        id: 20,
        name: types_1.ReviewSourceNames.InvitationLinkApiName,
        isVerified: true,
        sourceGroup: types_1.SourceGroups.GeneratedLink,
        defaultVerificationLevel: types_1.DefaultVerificationLevels.Invited
    },
    {
        id: 21,
        name: types_1.ReviewSourceNames.UniqueLinkName,
        isVerified: true,
        sourceGroup: types_1.SourceGroups.GeneratedLink,
        defaultVerificationLevel: types_1.DefaultVerificationLevels.Invited
    },
    {
        id: 22,
        name: types_1.ReviewSourceNames.MagentoName,
        isVerified: true,
        sourceGroup: types_1.SourceGroups.AutomaticInvitation,
        defaultVerificationLevel: types_1.DefaultVerificationLevels.Verified
    },
    {
        id: 23,
        name: types_1.ReviewSourceNames.ManualInputInvitationName,
        isVerified: true,
        sourceGroup: types_1.SourceGroups.ManualInvitation,
        defaultVerificationLevel: types_1.DefaultVerificationLevels.Invited
    },
    {
        id: 24,
        name: types_1.ReviewSourceNames.OrganicName,
        isVerified: false,
        sourceGroup: types_1.SourceGroups.Organic,
        defaultVerificationLevel: types_1.DefaultVerificationLevels.NotVerified
    },
    {
        id: 25,
        name: types_1.ReviewSourceNames.ShopifyName,
        isVerified: true,
        sourceGroup: types_1.SourceGroups.AutomaticInvitation,
        defaultVerificationLevel: types_1.DefaultVerificationLevels.Verified
    },
    {
        id: 26,
        name: types_1.ReviewSourceNames.WooCommerceName,
        isVerified: true,
        sourceGroup: types_1.SourceGroups.AutomaticInvitation,
        defaultVerificationLevel: types_1.DefaultVerificationLevels.Verified
    },
    {
        id: 27,
        name: types_1.ReviewSourceNames.InvitationScript,
        isVerified: true,
        sourceGroup: types_1.SourceGroups.AutomaticInvitation,
        defaultVerificationLevel: types_1.DefaultVerificationLevels.Verified
    },
    {
        id: 28,
        name: types_1.ReviewSourceNames.PrestaShop,
        isVerified: true,
        sourceGroup: types_1.SourceGroups.AutomaticInvitation,
        defaultVerificationLevel: types_1.DefaultVerificationLevels.Verified
    },
    {
        id: 29,
        name: types_1.ReviewSourceNames.MagentoV1,
        isVerified: true,
        sourceGroup: types_1.SourceGroups.AutomaticInvitation,
        defaultVerificationLevel: types_1.DefaultVerificationLevels.Verified
    },
    {
        id: 30,
        name: types_1.ReviewSourceNames.MagentoV2,
        isVerified: true,
        sourceGroup: types_1.SourceGroups.AutomaticInvitation,
        defaultVerificationLevel: types_1.DefaultVerificationLevels.Verified
    },
    {
        id: 31,
        name: types_1.ReviewSourceNames.OpenCart,
        isVerified: true,
        sourceGroup: types_1.SourceGroups.AutomaticInvitation,
        defaultVerificationLevel: types_1.DefaultVerificationLevels.Verified
    },
    {
        id: 32,
        name: types_1.ReviewSourceNames.Segment,
        isVerified: true,
        sourceGroup: types_1.SourceGroups.AutomaticInvitation,
        defaultVerificationLevel: types_1.DefaultVerificationLevels.Verified
    },
    {
        id: 33,
        name: types_1.ReviewSourceNames.Shopware,
        isVerified: true,
        sourceGroup: types_1.SourceGroups.AutomaticInvitation,
        defaultVerificationLevel: types_1.DefaultVerificationLevels.Verified
    },
    {
        id: 34,
        name: types_1.ReviewSourceNames.DomainLinkName,
        isVerified: false,
        sourceGroup: types_1.SourceGroups.Organic,
        defaultVerificationLevel: types_1.DefaultVerificationLevels.Redirected
    },
    {
        id: 35,
        name: types_1.ReviewSourceNames.Wix,
        isVerified: true,
        sourceGroup: types_1.SourceGroups.AutomaticInvitation,
        defaultVerificationLevel: types_1.DefaultVerificationLevels.Verified
    },
    {
        id: 36,
        name: types_1.ReviewSourceNames.GoogleTagManager,
        isVerified: true,
        sourceGroup: types_1.SourceGroups.AutomaticInvitation,
        defaultVerificationLevel: types_1.DefaultVerificationLevels.Verified
    },
    {
        id: 37,
        name: types_1.ReviewSourceNames.Square,
        isVerified: true,
        sourceGroup: types_1.SourceGroups.AutomaticInvitation,
        defaultVerificationLevel: types_1.DefaultVerificationLevels.Verified
    },
    {
        id: 38,
        name: types_1.ReviewSourceNames.PayPal,
        isVerified: true,
        sourceGroup: types_1.SourceGroups.AutomaticInvitation,
        defaultVerificationLevel: types_1.DefaultVerificationLevels.Verified
    },
    {
        id: 39,
        name: types_1.ReviewSourceNames.Salesforce,
        isVerified: true,
        sourceGroup: types_1.SourceGroups.AutomaticInvitation,
        defaultVerificationLevel: types_1.DefaultVerificationLevels.Verified
    },
    {
        id: 40,
        name: types_1.ReviewSourceNames.BannerRedirect,
        isVerified: true,
        sourceGroup: types_1.SourceGroups.GeneratedLink,
        defaultVerificationLevel: types_1.DefaultVerificationLevels.Invited
    },
    {
        id: 41,
        name: types_1.ReviewSourceNames.HubSpot,
        isVerified: true,
        sourceGroup: types_1.SourceGroups.AutomaticInvitation,
        defaultVerificationLevel: types_1.DefaultVerificationLevels.Verified
    },
    {
        id: 42,
        name: types_1.ReviewSourceNames.VerifiedWidgetForm,
        isVerified: true,
        sourceGroup: types_1.SourceGroups.EmbeddedReviewForm,
        defaultVerificationLevel: types_1.DefaultVerificationLevels.Invited
    },
];
var allReviewSources = __spreadArray(__spreadArray([], legacyReviewSources, true), currentReviewSources, true);
function mapCountry(source, translationLocale) {
    var localizationKey = source["country"].toLowerCase();
    var target = Object.assign({}, source);
    target.englishName = localization.get(defaultLocale, "countries", localizationKey);
    target.translatedName = localization.get(translationLocale, "countries", localizationKey);
    return target;
}
function mapLocale(source, translationLocale, trustpilotHost) {
    var localizationKey = source["locale"].toLowerCase();
    var target = Object.assign({}, source);
    replaceTpHosts(target, trustpilotHost, [
        "consumerWebApp",
        "businessWebApp",
        "legalUrl",
        "commercialUrl",
        "aboutTrustpilotUrl",
        "supportUrl",
        "helpCenterUrl",
        "blog",
        "businessSignupUrl",
        "pressUrl",
        "investorsUrl",
        "jobsUrl",
        "statusPageUrl",
        "impressumPageUrl",
    ]);
    target.nativeName = localization.get(source["locale"], "locales", localizationKey);
    target.translatedName = localization.get(translationLocale, "locales", localizationKey);
    return target;
}
function getCountries(locale) {
    if (locale === void 0) { locale = defaultLocale; }
    var localeObj = localization.parseLocale(locale);
    return {
        countries: countries.map(function (x) { return mapCountry(x, localeObj); }),
    };
}
function getLocale(locale, translationLocale, trustpilotHost) {
    if (translationLocale === void 0) { translationLocale = defaultLocale; }
    if (trustpilotHost === void 0) { trustpilotHost = "trustpilot.com"; }
    var translationLocaleObj = localization.parseLocale(translationLocale);
    var localeObj = locales.find(function (x) { return x.locale.toLowerCase() == locale.toLowerCase(); }) ||
        locales.find(function (x) { return x.locale == defaultLocale; });
    if (!localeObj) {
        throw new Error("No locale object was found for the string ".concat(locale, " or ").concat(defaultLocale, ". Locales that were searched through: ").concat(locales));
    }
    return mapLocale(localeObj, translationLocaleObj, trustpilotHost);
}
function getLocales(translationLocale, trustpilotHost) {
    if (translationLocale === void 0) { translationLocale = defaultLocale; }
    if (trustpilotHost === void 0) { trustpilotHost = "trustpilot.com"; }
    var translationLocaleObj = localization.parseLocale(translationLocale);
    var mappedLocales = locales.map(function (x) {
        return mapLocale(x, translationLocaleObj, trustpilotHost);
    });
    return {
        locales: mappedLocales,
        defaultLocale: mappedLocales.find(function (x) { return x.locale == defaultLocale; }),
    };
}
function replaceTpHosts(target, trustpilotHost, targetProps) {
    for (var _i = 0, targetProps_1 = targetProps; _i < targetProps_1.length; _i++) {
        var key = targetProps_1[_i];
        var propertyValue = target[key];
        if (typeof propertyValue === "string") {
            target[key] = propertyValue.replace("trustpilot.com", trustpilotHost);
        }
    }
}
function getReviewSourceGroup(reviewSource, locale) {
    return localization.get(locale, "review-source-group", reviewSource);
}
function getAllReviewSources(locale) {
    if (locale === void 0) { locale = defaultLocale; }
    var validatedLocale = localization.parseLocale(locale);
    return allReviewSources.map(function (source) {
        return {
            id: source.id,
            name: source.name,
            isVerified: source.isVerified,
            sourceGroup: {
                id: source.sourceGroup,
                translatedNameSingular: getReviewSourceGroup("".concat(source.sourceGroup, "-singular"), validatedLocale),
                translatedNamePlural: getReviewSourceGroup("".concat(source.sourceGroup, "-plural"), validatedLocale),
            },
        };
    });
}
function getReviewSourceNameById(id) {
    var source = allReviewSources.find(function (source) { return source.id === id; });
    if (!source) {
        throw Error("Review source with id ".concat(id, " not found."));
    }
    return source.name;
}
function getReviewSourceById(id) {
    var reviewSource = allReviewSources.find(function (source) { return source.id === id; });
    if (!reviewSource) {
        throw Error("Review source with id ".concat(id, " not found."));
    }
    return reviewSource;
}
function getReviewSourceByName(name) {
    var reviewSource = allReviewSources.find(function (source) { return source.name.toLowerCase() === name.toLowerCase(); });
    if (!reviewSource) {
        throw Error("Review source with name ".concat(name, " not found."));
    }
    return reviewSource;
}
